<template>
	<div class="p4">
		<!-- Input contentJsonString -->
		<div v-if="step === 1">
			<div class="xs-12 pb2 fs3 fw7">{{ $t("contentJsonString") }}</div>
			<core-monaco-editor v-model="contentJsonString" />
			<j-button @click="preview" class="mt4">{{ $t("preview") }}</j-button>
		</div>

		<!-- Visualize render -->
		<div v-if="step === 2">
			<div v-html="renderedHtml" />
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import CoreMonacoEditor from "@/modules/core/components/CoreMonacoEditor"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	props: {
		html: String
	},

	components: { JButton, CoreMonacoEditor },

	data() {
		return {
			contentJsonString: null,
			step: 1,
			renderedHtml: null
		}
	},

	created() {
		/* Find variables names in the html templates to prepopulate the contentJsonString */
		let variables = this.html
			.match(/[^{\}]+(?=})/g)
			.map(item => item.trim())
			.filter(item => item?.length)
			.filter(item => item.startsWith("data."))
			.map(item => '"' + item.replace("data.", "") + '"')
			.join(': "",\n  ')
		this.contentJsonString = "{\n  " + variables + ': ""\n}'
	},

	methods: {
		async preview() {
			/* RenderHTML */
			const query = gql`
				query renderHTML(
					$html: String!
					$input: templateRenderParametersInput
				) {
					renderHtml(html: $html, input: $input) {
						errors
						value
					}
				}
			`
			const variables = {
				html: this.html,
				input: { contentJsonString: this.contentJsonString, name: "data" }
			}
			const res = await api({ query, variables })
			if (res?.data?.errors?.length) {
				this.$store.dispatch("showError", res.data.errors)
			} else {
				this.renderedHtml = res.data?.renderHtml?.value
				this.step = 2
			}
		}
	}
}
</script>
